import { RefreshCw01, Trash02, User01 } from '@untitled-ui/icons-react';

import { Avatar } from '../../../../../../components/avatar';
import { Badge } from '../../../../../../components/badge';
import { IconButton } from '../../../../../../components/buttons/icon-button';
import { DropdownMenu, DropdownMenuItem } from '../../../../../../components/dropdown-menu';
import { AnimatedDotsIcons } from '../../../../../../components/icons/animatedDotsIcons';
import { tNamespace } from '../../../../../../services/translation';

const t = tNamespace('app.settings.organization.users');

type UserUserInvitedProps = {
  email: string;
  onEdit: () => void;
  revokeInvite: () => void;
};

export function UserUserInvited(props: UserUserInvitedProps) {
  const { email, onEdit, revokeInvite } = props;
  return (
    <div className="flex items-center gap-2">
      <Avatar icon={<User01 width={20} height={20} />} size="md" className="opacity-50" />
      <div className="flex flex-1 flex-col opacity-50">
        <p className="font-body-2-m flex gap-1">{email}</p>
      </div>
      <Badge size="sm" color="gray">
        {t('invited')}
      </Badge>
      <DropdownMenu
        trigger={
          <IconButton
            isDiv={true}
            size="xs"
            variant="ghost-neutral"
            icon={<AnimatedDotsIcons groupName="group/dots-icon" />}
          />
        }
        triggerClassName="group/dots-icon"
      >
        <DropdownMenuItem
          label={
            <div className="flex items-center gap-2">
              <RefreshCw01 width={16} height={16} />
              <p>{t('resendInvitation')}</p>
            </div>
          }
          onClick={onEdit}
        />
        <DropdownMenuItem
          label={
            <div className="text-branding-red flex items-center gap-2">
              <Trash02 width={16} height={16} className="text-red-500" />
              <p className="text-red-500">{t('cancelInvitation')}</p>
            </div>
          }
          onClick={revokeInvite}
        />
      </DropdownMenu>
    </div>
  );
}
